import { api, authHeaders } from "@/lib/api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) out[i] = raw.charCodeAt(i);
  return out;
}

export function pushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}
export function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent);
}
export function isStandalone() {
  return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
}

export async function enablePush(role) {
  if (!pushSupported()) throw new Error("Le notifiche non sono supportate su questo browser.");
  if (isIOS() && !isStandalone()) {
    throw new Error("Su iPhone aggiungi prima l'app alla schermata Home (Condividi → Aggiungi a Home), poi apri l'app e riattiva.");
  }
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Permesso notifiche negato.");
  const reg = await navigator.serviceWorker.register("/sw.js");
  await navigator.serviceWorker.ready;
  const { data } = await api.get("/push/vapid-public-key");
  if (!data.enabled || !data.key) throw new Error("Notifiche push non disponibili.");
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.key),
    });
  }
  await api.post(`/${role}/push/subscribe`, { subscription: sub.toJSON() }, { headers: authHeaders(role) });
  return true;
}

export function pushEnabled() {
  return pushSupported() && Notification.permission === "granted";
}
